export const SPARKY_FRAMEWORK = 'sparky-framework'

// MICRO APPS
export const COMMON_SERVICES_MICRO_APP_NAME = 'cloud-mgmt'
export const COMMON_SERVICES_MICRO_APP_ID = 'cloud-mgmt-modules'
export const SCM_ONE_NAV_APP_NAME = 'sparky-one-nav'
export const FAWKES_MICRO_APP_NAME = 'management-app'
export const MSP_MICRO_APP_NAME = 'sase-msp'
export const SDWAN_MICRO_APP_NAME = 'sdwan'
export const ASC_PORTAL_MICRO_APP = 'asc-partner-app'
export const DASHBOARDS_MICRO_APP = 'dashboards-core-service'
export const SAAS_MICRO_APP_NAME = 'saas-inline-fawkes'
export const DLP_MICRO_APP_NAME = 'dlp'
export const PAI_MICRO_APP_NAME = 'pai'

// URL KEYS
export const ADMIN_CLUSTER_URL_NAME = 'admin_cluster_url'
export const API_SERVICE_URLS_NAME = 'api_service_urls'
export const INSTANCE_STORE_URL_KEY = 'instance_store'
export const TENANCY_SERVICE_URL_KEY = 'tenancy_service'
export const IAM_SERVICE_URL_KEY = 'iam_service'
export const IDENTITY_SERVICE_URL_KEY = 'identity_service'
export const SUBSCRIPTION_SERVICE_URL_KEY = 'subscription_service'
export const APP_REGISTRY_URL_KEY = 'app_registry'
export const API_GATEWAY_URL_KEY = 'api_gateway'
export const PREFERENCE_SERVICE_URL_KEY = 'preference_service'
export const API_GW_GLOBAL_SVC_URL_KEY = 'api_gateway_global_service'
export const COSMOS_URL_KEY = 'cosmos'
export const PAI_URL_KEY = 'pai'
export const REGIONAL_URL_KEYS = [COSMOS_URL_KEY]
export const HUB_URL_KEY = 'app_portal'
export const SASE_URL_KEY = 'sase_portal'
export const SASE_CN_URL_KEY = 'sase_cn_portal'
export const SCM_URL_KEY = 'netsec_portal'
export const MSP_URL_KEY = 'msp_portal'
export const MSP_GOV_URL_KEY = 'msp_portal_gov'

// CLIENT IDS
export const SCM_CLIENT_ID = 'scm'
export const SCM_CLIENT_IDS = [SCM_CLIENT_ID, 'strata', 'netsec']
export const SASE_CLIENT_ID = 'sase'
export const SASE_CN_CLIENT_ID = 'sase-cn'
export const HUB_CLIENT_ID = 'hub'

// COB APP IDS
export const FAWKES_APP_ID = 'prisma_access'
export const MSP_BUCK_CONFIG_APP_ID = 'bulk_config'
export const FAWKES_APP_IDS = [FAWKES_APP_ID, MSP_BUCK_CONFIG_APP_ID] // for both pa, bulk_config, or future cloud_management, with order
export const PA_PANORAMA_APP_ID = 'prisma_access_panorama'
export const PAE_APP_ID = 'prisma_access_edition'
export const CDL_APP_ID = 'logging_service'
export const CIE_APP_ID = 'directory_sync'
export const DLP_APP_ID = 'dlp'
export const SAAS_APP_ID = 'aperture'
export const NG_CASB_APP_ID = 'ng_casb'
export const SCM_APP_ID = 'strata_cloud_manager'
export const SDWAN_APP_ID = 'cgx'
export const AIOPS_APP_ID = 'strata_insights'
export const AIOPS_FREE_APP_ID = 'strata_insights_free'
export const SCM_MERGE_APP_IDS = [SCM_APP_ID, AIOPS_APP_ID, FAWKES_APP_ID, SDWAN_APP_ID] // NG_CASB_APP_ID, SAAS_APP_ID, DLP_APP_ID

// PATHS
export const MULTI_TENANT_PATH_PREFIX_REGEX = /^\/(msp|setup|hub|activation|ztpdeviceactivation|asc)\b/
export const NON_FAWKES_PATH_PREFIX_REGEX = /^\/(sdwan|cie|msp|setup|hub|activate|activation|aiops-free|casb|ztpdeviceactivation|settings|asc)\b/
export const FAWKES_MGMT_PATH_PREFIX_REGEX = /^\/(overview|manage\/(?!sdwan|security-posture|saas-security|security-service\/data-loss-prevention))\b/
export const PA_DEFAULT_ROUTE = '/prisma-access'
export const DLP_DEFAULT_ROUTE = '/data-loss-prevention'
export const CIE_DEFAULT_ROUTE = '/cie'
export const MGMT_OVERVIEW_ROUTE = '/overview'
export const MGMT_MANAGE_ROUTE = '/manage'
export const MSP_PATH_PREFIX = '/msp' // TODO: could be different
export const SDWAN_PATH_PREFIX = '/sdwan'
export const ASC_PATH_PREFIX = '/asc'
export const DASHBOARDS_PATH_PREFIX = '/dashboards'
export const HOME_PATH = '/home'
export const EAZY_ONBOARDING_PATH_PREFIX = '/setup/'

// THEMES
export const DARK_THEME = 'dark'
export const LIGHT_THEME = 'light'
export const SYSTEM_THEME = 'system'
export const ALLOWED_THEME_PREF = [LIGHT_THEME, DARK_THEME, SYSTEM_THEME]
// export const ALLOWED_ACTUAL_THEME = [LIGHT_THEME, DARK_THEME]
export const APPLY_THEME_EVENT = 'apply-theme'
export const TW_DARK_CLS = 'tw-dark'

// ROLES
export const ASC_TIER_1_SUPPORT_ROLE = 'tier_1_support'
export const BROWSER_ROLE = 'browser'

// OTHERS

export const TSG_ID = 'tsg_id'
export const TSG_ID_QUERY_NAMES = [TSG_ID, 'tsgid', 'tsgId', 'tsg-id']
export const TSG_ID_REGEX = /^\d+$/
export const TSG_ID_NONE = 'none'

export const RUNNING = 'running'
export const MIGRATING = 'migrating'
export const CN_REGION = 'cn'
export const GOV_REGION = 'gov'

export const PANW_DOMAIN = 'paloaltonetworks.com'

export const PANORAMA = 'panorama'
export const ONPREM = 'onprem'
export const _ONPREM = '_onprem'

export const REQUEST_TIMEOUT = 30000 // 30s

export const DEFAULT_ROOT_ELEMENT_ID = 'fawkes-root'

export const OIDC_STORE_PREFIX = 'oidc.'

export const NSC_PAGE_FILTERS_KEY = 'nscPageFilters'
export const EMPTY_NSC_PAGE_FILTERS = Object.seal({})

export const ALLOW_REDIRECT_ROUTES = ['/']
export const PREFERENCES = {
  HIDE_WELCOME_POPUP: 'hideWelcomePopup',
}

export const DEFAULT_TSG_OIDC_CONFIG = {
  redirect_uri: '/authentication/silent_callback',
  response_type: 'code',
  silent_redirect_uri: '/authentication/silent_callback',
  automaticSilentRenew: true,
  loadUserInfo: false,
  accessTokenExpiringNotificationTime: 180, // 3min
}

export const EMPTY_SAML_DATA = {
  supportaccountids: '[]',
  notonorafter: '',
  accesstoken: '""',
  pingcert: '""',
  supportAccountIds: [],
}
